
import { filterByDate, filterCVEsBySeverity } from './dashboardDataProcessors';
import { getDaysAgo } from './dateUtils';
import { VulnerabilityItem } from '@/types/dashboard';

/**
 * Process CVE data into severity categories
 */
/**
 * Process CVE data into severity categories
 */
export function processCVEData(cveData: any, days: number = 30) {
  const startDate = getDaysAgo(days);
  const previousStartDate = getDaysAgo(days * 2);
  const cveArray = Array.isArray(cveData) ? cveData : [];



  const recentCVEs = filterByDate(cveArray, 'publishedDate', startDate);

  const previousCVEs = cveArray.filter(item => {
    const date = new Date(item.publishedDate);
    return date >= previousStartDate && date < startDate;
  });

  // Helper to filter by severity
  const filterBySev = (items: any[], min: number, max: number, severity: string, severityPl: string) => {
    return filterCVEsBySeverity(items, min, max, severity, severityPl);
  };

  // Current Period
  const criticalRaw = filterBySev(recentCVEs, 9.0, 10.0, 'critical', 'krytyczna');
  const highRaw = filterBySev(recentCVEs, 7.0, 9.0, 'high', 'wysoka');
  const mediumRaw = filterBySev(recentCVEs, 4.0, 7.0, 'medium', 'średnia');
  const lowRaw = filterBySev(recentCVEs, 0.1, 4.0, 'low', 'niska');

  // Previous Period
  const prevCriticalRaw = filterBySev(previousCVEs, 9.0, 10.0, 'critical', 'krytyczna');
  const prevHighRaw = filterBySev(previousCVEs, 7.0, 9.0, 'high', 'wysoka');
  const prevMediumRaw = filterBySev(previousCVEs, 4.0, 7.0, 'medium', 'średnia');
  const prevLowRaw = filterBySev(previousCVEs, 0.1, 4.0, 'low', 'niska');

  // Prepare CVE data with proper localized fields
  const processCVEItem = (cve: any): VulnerabilityItem => {
    return {
      id: cve.id || cve.name || cve.cve_id || 'Unknown',
      name: cve.name || '',
      description: cve.description || cve.desc_en || '',
      description_pl: cve.desc_pl || cve.description_pl || '',
      score: parseFloat(cve.score) || 0,
      publishedDate: cve.publishedDate || new Date().toISOString()
    };
  };

  const sortAndMap = (items: any[]) => {
    return [...items]
      .sort((a, b) => {
        const dateA = new Date(a.publishedDate).getTime();
        const dateB = new Date(b.publishedDate).getTime();
        return dateB - dateA;
      })
      .map(processCVEItem) as VulnerabilityItem[];
  };

  // Lists for cards
  const recentCriticalVulnerabilities = sortAndMap(criticalRaw);
  const recentHighVulnerabilities = sortAndMap(highRaw);
  const recentMediumVulnerabilities = sortAndMap(mediumRaw);
  const recentLowVulnerabilities = sortAndMap(lowRaw);

  return {
    criticalVulnerabilities: criticalRaw,
    highVulnerabilities: highRaw,
    mediumVulnerabilities: mediumRaw,
    lowVulnerabilities: lowRaw,
    recentCriticalVulnerabilities, // Critical
    recentHighVulnerabilities,     // High
    recentMediumVulnerabilities,   // Medium
    recentLowVulnerabilities,      // Low
    // Return counts for previous period
    prevCriticalCount: prevCriticalRaw.length,
    prevHighCount: prevHighRaw.length,
    prevMediumCount: prevMediumRaw.length,
    prevLowCount: prevLowRaw.length
  };
}
